import React, { forwardRef, useEffect, useRef, useState } from 'react'

import { useHistory, useLocation } from 'react-router-dom'
import Api from '../../../_helpers/Api'
import loader from '../../../assets/img/loader.svg'
import { trans } from '../../../_providers/Translation'
import { useWindowSize } from '../../../_helpers/WindowSizeHook'
import GroupedBarChart from '../../partials/GroupedBarChart'
import { getPaletteColor } from '../../partials/chartTheme'
import Filter from './partials/FilterStats'

let timeout

function Stats(props, ref) {

    const history = useHistory()
    const location = useLocation()
    const windowSize = useWindowSize()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: {
            dates: [],
            employees: []
        },
        filter: {},
        setFilter: false,
        update: false,
        employees: [],
        summary: true,
        allowDetails: false,
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                status: searchParams.get('status') || '',
                start: searchParams.get('start') || '',
                end: searchParams.get('end') || '',
                employee_id: searchParams.get('employee_id') || '',
                group: searchParams.get('group') || '',
            },
            update: new Date().getTime()
        }))

    }, [location.search])

    useEffect(() => {

        if (state.setFilter) {
            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    useEffect(() => {
        Api.get('partners/employees/all')
            .then(res => {
                setState(table => ({
                    ...table,
                    employees: res.data
                }))
            })
    }, [])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'accounts/voicecalls'

        Object.entries(state.filter).map(filter => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                    // chart: chart,
                    filter: {
                        ...prev.filter,
                        group: res.data.group,
                        start: res.data.start,
                        end: res.data.end
                    },
                    summary: res.data.employees.length === 0 ? true : prev.summary,
                    allowDetails: res.data.employees.length === 0 ? false : true,
                    loading: false
                }))
            })
    }

    const handleSearch = (key, val, delay = 300) => {

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            setFilter: new Date().getTime()
        }))

    }

    const toggleSummaryData = val => {
        setState(prev => ({
            ...prev,
            summary: val
        }))
    }

    const getColumns = () => {
        let arr = []

        state.data.methods.map((m, i) => {
            arr.push({
                type: 'NumberFormat',
                column: i + 1,
                options: {
                    // prefix: '$',
                    negativeParens: false,
                }
            })
        })

        return arr
    }

    const toList = (employeeId, start, end) => {
        let url = '/communication/voicecalls?tab=list'

        let params = {
            'employee_id': employeeId || '',
            'start': start || '',
            'end': end || '',
            'status': state.filter.status || ''
        }

        Object.entries(params).map(p => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + p[0] + '=' + p[1]
        })

        history.push(url)
    }

    const chartLabels = (state.data.dates || []).map(d => d.label)

    const chartSeries = state.summary
        ? [
            {
                name: trans('random.calls'),
                color1: getPaletteColor(0).color1,
                color2: getPaletteColor(0).color2,
                data: (state.data.dates || []).map(d => Number(d.total) || 0),
            },
        ]
        : (state.data.employees || []).map((c, i) => ({
            name: `${c.name} ${c.lastname || ''}`.trim(),
            color1: getPaletteColor(i).color1,
            color2: getPaletteColor(i).color2,
            data: (state.data.dates || []).map(d => Number(c.dates[d.date]?.total) || 0),
        }))

    return (
        <>
            <Filter
                allowDetails={state.allowDetails}
                filter={state.filter}
                summary={state.summary}
                employees={state.employees}
                handleSearch={handleSearch}
                toggleSummaryData={toggleSummaryData}
            />

            <hr />

            {state.loading
                ?
                <img className="loader" src={loader} />
                :
                <>
                    <div
                        className="chart"
                        style={{
                            background: '#fff',
                            padding: '5px'
                        }}>
                        <div className="head">
                            <ul>
                                {chartSeries.map((s, i) => (
                                    <li
                                        key={'legend-' + i}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            marginRight: 16,
                                            fontSize: 13,
                                            color: '#64748b',
                                        }}
                                    >
                                        <span
                                            style={{
                                                width: 12,
                                                height: 12,
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                backgroundImage: `linear-gradient(to bottom, ${s.color1}, ${s.color2})`,
                                            }}
                                        />
                                        {s.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <GroupedBarChart
                            labels={chartLabels}
                            series={chartSeries}
                            roundedBottom
                        />
                    </div>

                    <hr />
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.employee')}
                                    </th>
                                    {state.data.dates.map((d, i) =>
                                        <th key={'th-' + i} className="right">
                                            {d.label}
                                        </th>
                                    )}
                                    <th className="right">
                                        {trans('tables.total')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.employees.map(c =>
                                    <tr key={'c-' + c.id}>
                                        <td>
                                            {c.name} {c.lastname}
                                        </td>
                                        {state.data.dates.map((d, i) =>
                                            <td
                                                key={'td-' + i}
                                                className="right clickable"
                                                onClick={() => toList(c.id, d.start_date, d.end_date)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {c.dates[d.date].total}
                                                <br />
                                                {c.dates[d.date].duration_formatted}
                                            </td>
                                        )}
                                        <td
                                            className="right clickable"
                                            onClick={() => toList(c.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {c.total}
                                            <br />
                                            {c.duration_formatted}
                                        </td>
                                    </tr>
                                )}

                                <tr>
                                    <td>
                                        {trans('tables.total')}
                                    </td>
                                    {state.data.dates.map((d, i) =>
                                        <td
                                            key={'totals-' + i}
                                            className="right clickable"
                                            onClick={() => toList(null, d.start_date, d.end_date)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {d.total}
                                            <br />
                                            {d.duration_formatted}
                                        </td>
                                    )}
                                    <td
                                        className="right clickable"
                                        onClick={() => toList()}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {state.data.total}
                                        <br />
                                        {state.data.duration_formatted}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </>
            }

        </>
    )
}

export default forwardRef(Stats)